/* unplugin-vue-components disabled */import { render } from "./TopMenuII.vue?vue&type=template&id=1bbd9f3d&scoped=true"
import script from "./TopMenuII.vue?vue&type=script&lang=js"
export * from "./TopMenuII.vue?vue&type=script&lang=js"

import "./TopMenuII.vue?vue&type=style&index=0&id=1bbd9f3d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bbd9f3d"]])

export default __exports__